import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { NavLink, To } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { collapsedMenuItemStyles, expandedMenuItemStyles } from '@/nav/utils/navigation.utils';

type NavItemProps = {
  selected: boolean;
  to: To;
  icon: JSX.Element;
  children?: string;
  isPadded?: boolean;
  expanded?: boolean;
};
function NavItem({
  selected,
  to,
  icon,
  children,
  isPadded = false,
  expanded = true,
}: NavItemProps) {
  return (
    <ListItem disablePadding role="menuitem">
      <ListItemButton
        selected={selected}
        component={NavLink}
        to={to}
        sx={expanded ? expandedMenuItemStyles(isPadded) : collapsedMenuItemStyles}
        title={children}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        {expanded ? (
          <ListItemText
            primaryTypographyProps={{ letterSpacing: '0.15px', whiteSpace: 'nowrap' }}
            sx={{ my: 0 }}
          >
            {children}
          </ListItemText>
        ) : null}
      </ListItemButton>
    </ListItem>
  );
}

export default NavItem;
